export const lightTheme = {
  body: "hsl(0, 0%, 98%)",
  text: "hsl(200, 15%, 8%)",
  toggleBorder: "#FFF",
  background: "hsl(0, 0%, 100%)",
  elements: "hsl(0, 0%, 100%)",
  shadow: "grey",
};
export const darkTheme = {
  body: "hsl(207, 26%, 17%)",
  text: "hsl(0, 0%, 100%)",
  toggleBorder: "#6B8096",
  background: "hsl(209, 23%, 22%)",
  elements: "hsl(209, 23%, 22%)",
  shadow: "black",
};

export const colors = {
  darkModeElements: "hsl(209, 23%, 22%)",
  darkModeBackground: "hsl(207, 26%, 17%)",
  lightModeText: "hsl(200, 15%, 8%)",
  lightModeInput: "hsl(0, 0%, 52%)",
  lightModeBackground: "hsl(0, 0%, 98%)",
  darkModeTextAndLightModeElements: "hsl(0, 0%, 100%)",
};
